var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2 mt-2",attrs:{"flat":"","rounded":"lg"}},[_c('v-card-subtitle',{staticClass:"subtitle-1 font-weight-bold black--text pb-1"},[_vm._v("Código Cliente Supermecado")]),_c('v-card-text',[_c('span',{staticClass:"headline green--text text--darken-4",style:({
        'letter-spacing': '7px !important',
        'font-family': 'Archivo Black !important',
      })},[_vm._v(_vm._s(_vm.usuarioLogado.matrcoasul))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }